export enum EnvkvType {
    EnVkvElektro = 'EnVkvElektro',
    EnVkvPlugInHybrid = 'EnVkvPlugInHybrid',
    EnVkvVerbrennerHybrid = 'EnVkvVerbrennerHybrid',
}
